import { UserCommitmentRankingService } from './UserCommitmentRankingService';

export default {
	'services.ranking.userCommitmentRankingService': {
		class: UserCommitmentRankingService,
	},
};
